export default {
  methods: {
    scrollToBottom ({ elSelector, containerSelector }) {
      const elem = document.querySelector(elSelector)
      const container = document.querySelector(containerSelector)
      container.scrollTop = Math.floor(elem.offsetHeight)
    }
  }
}
